import {Component, Inject, OnInit} from '@angular/core';
import {ChartType, Chat, Stat, Transaction} from '../../dashboard/dashboard.model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DashboardService} from '../../../services/dashboard.service';
import {AlertService} from 'ngx-alerts';
import {LOCAL_STORAGE, StorageService} from 'ngx-webstorage-service';
import {NgxSpinnerService} from 'ngx-spinner';
import {latLng, tileLayer} from 'leaflet';
import {finalize} from 'rxjs/operators';

@Component({
  selector: 'app-driving-school-dashboard',
  templateUrl: './driving-school-dashboard.component.html',
  styleUrls: ['./driving-school-dashboard.component.scss']
})
export class DrivingSchoolDashboardComponent implements OnInit {

  chatData: Chat[];
  transactions: Transaction[];
  statData: Stat[];

  loggedInUser: any;
  dashboardSearch = {
    channelId: '',
    userType: 'drivingSchool'
  };
  loggedInUserData: any;

  dashboardData: any;
  businessOverViewData: any = {
    'totalDownloads': '-',
    'earningsFromDownloads': '-',
    'outStandingBalance': '-',
    'openingAccountBalance': '-',
    'totalReferralSales': '-',
    'earningsFromCommission': '-',
    'totalEarnings': '-'
  };
  totalCustomersInLast6Months = 0;

  constructor(public formBuilder: FormBuilder, public dashboardService: DashboardService, private alertService: AlertService,
              @Inject(LOCAL_STORAGE) private storage: StorageService, private spinner: NgxSpinnerService) {
    this.loggedInUser = storage.get('gs-loggedInUser');
    this.loggedInUserData = storage.get('gs-loggedInUserData');
    this.dashboardSearch.channelId = this.loggedInUser.channelId;
  }

  // bread crumb items
  breadCrumbItems: Array<{}>;

  revenueChart: ChartType;
  salesAnalytics: ChartType;
  sparklineEarning: ChartType;
  sparklineMonthly: ChartType;

  alertsAnalytics: ChartType;
  // Form submit
  chatSubmit: boolean;

  formData: FormGroup;
  lineBarChart: any;


  options = {
    layers: [
      tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {maxZoom: 18, attribution: '...'})
    ],
    zoom: 6,
    center: latLng(46.879966, -121.726909)
  };
  totalWeekCustomers = 0;
  weekChart: any;
  public userType = this.storage.get('gs-loggedInUserType');

  ngOnInit(): void {
    this.breadCrumbItems = [{label: 'Gypsee'}, {label: 'Dashboard', active: true}];
    this.formData = this.formBuilder.group({
      message: ['', [Validators.required]],
    });
    this._fetchData();
    this.getDashboardData();
  }

  private _fetchData() {
    this.revenueChart = undefined;
    this.sparklineEarning = undefined;
    this.sparklineMonthly = undefined;
    this.chatData = undefined;
    this.transactions = undefined;
    this.statData = undefined;
  }

  /**
   * Returns form
   */
  get form() {
    return this.formData.controls;
  }

  /**
   * Save the message in chat
   */
  messageSave() {
    const message = this.formData.get('message').value;
    const currentDate = new Date();
    if (this.formData.valid && message) {
      // Message Push in Chat
      this.chatData.push({
        align: 'right',
        name: 'Ricky Clark',
        message,
        time: currentDate.getHours() + ':' + currentDate.getMinutes()
      });

      // Set Form Data Reset
      this.formData = this.formBuilder.group({
        message: null
      });
    }

    this.chatSubmit = true;
  }

  private getDashboardData() {
    this.spinner.show();
    this.dashboardService.getDashboardData(this.dashboardSearch).pipe(finalize(() => this.spinner.hide())).subscribe(
      (res: any) => {
        if (res && res.data) {
          this.dashboardData = res.data;
          this.businessOverViewData = res.drivingSchoolBusinessOverview;
        }
      }, error1 => {
        console.error(error1);
        this.alertService.danger(error1.message ? error1.message : error1);
      }
    );
  }

  onBranchSelect(value: any) {
    this.dashboardSearch.channelId = value.channelId;
    this.getDashboardData();
  }

  private processChartData() {
    this.salesAnalytics = {
      series: [this.dashboardData.totalInsuranceReminders, this.dashboardData.totalServiceRemindersOfCustomers, this.dashboardData.totalPollutionReminders],
      chart: {
        height: 230,
        type: 'donut',
      },
      labels: ['Insurance Reminders', 'Service Reminders', 'Pollution Reminders'],
      plotOptions: {
        pie: {
          donut: {
            size: '75%'
          }
        }
      },
      dataLabels: {
        enabled: false
      },
      legend: {
        show: false,
      },
      colors: ['#5664d2', '#1cbb8c', '#eeb902'],
    };

    this.alertsAnalytics = {
      series: [this.dashboardData.totalVehicleAlertsCount, this.dashboardData.totalDrivingAlertsCount],
      chart: {
        height: 230,
        type: 'donut',
      },
      labels: ['Vehicle Trouble Codes', 'Driving Alerts'],
      plotOptions: {
        pie: {
          donut: {
            size: '75%'
          }
        }
      },
      dataLabels: {
        enabled: false
      },
      legend: {
        show: false,
      },
      colors: ['#5664d2', '#1cbb8c', '#eeb902'],
    };

    if (this.dashboardData.last6MonthsCustomersCount) {
      let barChartLabels = this.dashboardData.last6MonthsCustomersCount.map(m => m.month);
      let barChartData = this.dashboardData.last6MonthsCustomersCount.map(m => m.customers);
      barChartData.forEach(bd => this.totalCustomersInLast6Months += +bd);
      this.lineBarChart = {
        labels: barChartLabels,
        datasets: [
          {
            label: 'No. of Customers',
            backgroundColor: 'rgba(52, 195, 143, 0.8)',
            borderColor: 'rgba(52, 195, 143, 0.8)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(52, 195, 143, 0.9)',
            hoverBorderColor: 'rgba(52, 195, 143, 0.9)',
            data: barChartData,
            barPercentage: 0.4,

          },
        ],
        options: {
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                gridLines: {
                  color: 'rgba(166, 176, 207, 0.1)'
                },
              }
            ],
            yAxes: [
              {
                gridLines: {
                  color: 'rgba(166, 176, 207, 0.1)'
                }, ticks: {
                  precision: 0,
                  min: 0
                }
              }
            ]
          }
        }
      };

      if (this.dashboardData.weekCustomersCount) {
        let barChartLabels = this.dashboardData.weekCustomersCount.map(m => m.dayName);
        let barChartData = this.dashboardData.weekCustomersCount.map(m => m.count);
        barChartData.forEach(bd => this.totalCustomersInLast6Months += +bd);
        this.weekChart = {
          labels: barChartLabels,
          datasets: [
            {
              label: 'No. of Sales/Day',
              backgroundColor: 'rgba(52, 195, 143, 0.8)',
              borderColor: 'rgba(52, 195, 143, 0.8)',
              borderWidth: 1,
              hoverBackgroundColor: 'rgba(52, 195, 143, 0.9)',
              hoverBorderColor: 'rgba(52, 195, 143, 0.9)',
              data: barChartData,
              barPercentage: 0.4,

            },
          ],
          options: {
            maintainAspectRatio: false,
            scales: {
              xAxes: [
                {
                  gridLines: {
                    color: 'rgba(166, 176, 207, 0.1)'
                  },
                }
              ],
              yAxes: [
                {
                  gridLines: {
                    color: 'rgba(166, 176, 207, 0.1)'
                  }, ticks: {
                    precision: 0,
                    min: 0
                  }
                }
              ]
            }
          }
        };
      }


    }

  }
}
